/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* AWS-specific vault configuration. 
*/
export class AwsVaultConfig {
  /**
  * The name of the bucket
  */
  'bucketName'?: string;
  /**
  * The prefix of the bucket.
  */
  'bucketPrefix'?: string;
  /**
  * ARN of the KMS key used for encryption.
  */
  'encryptionKey'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "bucketName",
      "baseName": "bucketName",
      "type": "string",
      "format": ""
    },
    {
      "name": "bucketPrefix",
      "baseName": "bucketPrefix",
      "type": "string",
      "format": ""
    },
    {
      "name": "encryptionKey",
      "baseName": "encryptionKey",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AwsVaultConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

